import { Component, OnInit } from '@angular/core';
import { UserService } from '../../_services';
import { EnterVoWD, CurrencyType, AddUser, Role, User, LoginUser, AssignUserOnBehalf, Supplier, CostCenter } from '../../_models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../_services/confirmation-dialog.service';
import { ModalPopupAlertComponent } from '../../_shared/modal-popup-alert/modal-popup-alert.component';
import { AddVowdComponent } from '../add-vowd/add-vowd.component';
import { VowdCommentComponent } from '../vowd-comment/vowd-comment.component';
import { Observable } from 'rxjs';
import { AddVOWDComment } from '../../_models/add-vowd-comment';
import { AdminService } from '../../_services/admin.service';
import { GlobalDataService } from '../../_shared';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { EneterVOWDComment } from '../../_models/enter-vowd-comment';


@Component({
  selector: 'app-enter-vowd',
  templateUrl: './enter-vowd.component.html',
  styleUrls: ['./enter-vowd.component.css']
})
export class EnterVowdComponent implements OnInit {
  config: any;
  lstAccruals: any[] = []; 
  suppliersResult: Supplier[] = [];
  userdataResult: AddUser[] = [];
  CostCentersResult: CostCenter[] = [];
  lstAccrualsbackup: any[] = [];
  lstAccrualsbackup2: any[] = [];
  ChkAll: any =false;
  resVowdList: any[] = [];
  lstCurrency: CurrencyType[] = [];
  lstresCurrency: CurrencyType[] = [];
  viewUsers: AddUser[] = [];
  viewallUsers: AddUser[] = [];
  SelectedUser :any ="";
  user: LoginUser = new LoginUser;
  sortAscBU : boolean = false;
  filterVoWD : boolean = false;
  clearbutton:boolean=false;
  searchText!: string;
  SupplierNametxtmodel!: string | null;
  Suppliershnametxtmodel! :string | null;
  SupplierABtxtmodel : any=null;
  ObjAccounttxtmodel: any=null;
  ContractIdModel: any=null;
  monthyeartxtmodel:any=null;
  Cstcentertxtmodel!: string | null;
  Divisionfieldtxtmodel!: string | null;
  VoWDAmounttxtmodel:any=null;
  Companycodetxtmodel:any=null;
  Areatxtmodel!: string | null;
  Departmenttxtmodel!: string | null;
  Workdescriptiontxtmodel!: string | null;
  Submitttedtxtmodel!: string | null;
  createdBytxtmodel!: string | null;
  getMonths: string[] = [];
  getYears : number[] =[];
  Month='';
  Year!: number;
  objectAccountsResult: string[] = [];
  assignUsers: AssignUserOnBehalf[] = [];
  flgSubmit =true;
  commentList :EneterVOWDComment[]=[];
  lstCostCenter: CostCenter[] = [];
  arrayListSupplierAB: Array<string> = [];
  arrayUsers: Array<string> = [];
  arrayListSupplierName: Array<string> = [];
  arrayListSuppliershortName: Array<string> = [];
  arrayListArea: Array<string> = [];
  arrayListDepartment: Array<string> = [];
  arrayListAreaDistinct: Array<string> = [];
  arrayDivisionField: Array<string> = [];
  arrayDivisionFieldDistinct: Array<string> = [];
  arrayListDepartmentDistinct: Array<string> = [];
  arrayCostCenter: Array<string> = [];
  lstAccount: string[] = [];
  SelectedProvisioningID!: string;
  p : any;
 
  constructor(
    private userService : UserService,
    private modalService: NgbModal,
    private confirmationDialogService: ConfirmationDialogService,
    private adminService  : AdminService,
    private gd : GlobalDataService) { }

  ngOnInit() {
    this.user = this.gd.getUserData();
    this.getMonths = this.gd.monthNames;
    this.SelectedProvisioningID = this.user.ProvisioningID;
    this.Month = this.getMonths[new Date().getMonth()] ;
    this.suppliersResult=this.gd.getSupplierData();
    this.lstCostCenter =this.gd.getCostCenterData();
    this.lstAccount =this.gd.getAccountData();
    this.getAllEndUsers();
    this.getYear();
    this.getAllUsers();
    this.getSuppliers();
    this.getObjectAccount();
    this.getCenterData();
    this.getallusersList();
  
    
  }

  getallusersList()
  {
    this.userdataResult=this.gd.getalluserData();
    this.arrayUsers=this.userdataResult.map(x=> x.ProvisioningID);
  }
  searchUsers = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayUsers.filter(v => v?.toLowerCase().indexOf(term?.toLowerCase()) > -1).slice(0, 10))
  )
  getSuppliers()
  {
    this.suppliersResult= this.gd.getSupplierData();
    this.arrayListSupplierAB = this.suppliersResult.map(sup => sup.SupplierAB?.toString().trim());
    this.arrayListSupplierName= this.suppliersResult.map(sup => sup.SupplierName?.toString().trim());
    this.arrayListSuppliershortName= this.suppliersResult.map(sup => sup.SupplierShortName?.toString().trim());
   
  }
  searchSupplierAB = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListSupplierAB.filter(v => v?.toLowerCase().indexOf(term?.toLowerCase()) > -1).slice(0, 10))
  )
  searchSupplierName = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListSupplierName.filter(v => v?.toLowerCase().indexOf(term?.toLowerCase()) > -1).slice(0, 10))
  )
  searchSupplierShortName = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListSuppliershortName.filter(v => v?.toLowerCase().indexOf(term?.toLowerCase()) > -1).slice(0, 10))
  )

  getObjectAccount()
  {
    this.objectAccountsResult=this.gd.getAccountData();
   
  }

  searchObjectAcnt = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.objectAccountsResult.filter(v => v?.toLowerCase().indexOf(term?.toLowerCase()) > -1).slice(0, 10))
  )
  getCenterData()
  {
    this.CostCentersResult= this.gd.getCostCenterData();
    this.arrayListArea = this.CostCentersResult.map(cost => (cost.Area_CODE!=null?cost.Area_CODE?.trim():cost.Area_CODE)+"-" +(cost.Area_description!=null?cost.Area_description?.trim():cost.Area_description)); 
    this.arrayListDepartment = this.CostCentersResult.map(cost =>cost.Division); 
    this.arrayCostCenter=this.CostCentersResult.map(cost=>cost.CostCenter?.trim());
    this.arrayDivisionField=this.CostCentersResult.map(cost=>cost.CostCenterDesc);
    this.arrayDivisionFieldDistinct=this.arrayDivisionField.filter((n, i) => this.arrayDivisionField.indexOf(n) === i);
    this.arrayListAreaDistinct = this.arrayListArea.filter((n, i) => this.arrayListArea.indexOf(n) === i);    
    this.arrayListDepartmentDistinct = this.arrayListDepartment.filter((n, i) => this.arrayListDepartment.indexOf(n) === i);
    for(var i = 1; i <= (this.arrayListAreaDistinct.length-1); i++)
    {
      this.arrayListAreaDistinct[i]?.trim();
    }
}

  searchCostcenter=(text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayCostCenter.filter(v => v?.toLowerCase().indexOf(term?.toLowerCase()) > -1).slice(0, 10))
  )
  searchDivisionField=(text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayDivisionFieldDistinct.filter(v => v?.toLowerCase().indexOf(term?.toLowerCase()) > -1).slice(0, 10))
  )

  searchArea = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListAreaDistinct.filter(v => v!=null && v?.toLowerCase().indexOf(term?.toLowerCase()) > -1).slice(0, 10))
  )

  searchDepartment = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListDepartmentDistinct.filter(v => v!=null && v?.toLowerCase().indexOf(term?.toLowerCase()) > -1).slice(0, 10))
  )
  
  getYear()
  {
    for (var i = 0; i <= 20; i++) {
      this.getYears.push((new Date().getFullYear()) - i);
      this.Year =new Date().getFullYear();
    }
  }

  getAllAccrual()
  {
    var empProvisioningID= this.SelectedUser==""? this.user.ProvisioningID: this.SelectedUser ;
    this.userService.viewVOWD(this.SelectedProvisioningID,this.Month +'-'+this.Year,this.SelectedUser).subscribe(data=>{
        this.lstAccruals = data;
        for (let i=0;i<this.lstAccruals.length;i++)
        {
          this.lstAccruals[i].SupName = this.suppliersResult.filter(t=>t.SupplierAB == this.lstAccruals[i]?.SupplierAB)[0].SupplierName;
          this.lstAccruals[i].SupShortName = this.suppliersResult.filter(t=>t.SupplierAB == this.lstAccruals[i]?.SupplierAB)[0].SupplierShortName;
          this.lstAccruals[i].ObjDescr = this.lstAccount.filter(t=>t.split('-')[0]?.trim()== this.lstAccruals[i]?.ObjectAccount?.trim())[0];
          this.lstAccruals[i].CCcode = this.lstCostCenter.filter(t=>t.CostCenter == this.lstAccruals[i]?.CostCenter)[0].CompanyCode;
        
        }
       
        if(this.clearbutton==true){
          this.clearbutton=false;
          this.SupplierNametxtmodel=null;
          this.Suppliershnametxtmodel =null;
          this.SupplierABtxtmodel =null;
          this.ObjAccounttxtmodel=null;
          this.monthyeartxtmodel=null;
          this.Cstcentertxtmodel=null;
          this.Divisionfieldtxtmodel=null;
          this.VoWDAmounttxtmodel=null;
          this.Companycodetxtmodel=null;
          this.Areatxtmodel=null;
          this.Departmenttxtmodel=null;
          this.Workdescriptiontxtmodel=null;
          this.Submitttedtxtmodel=null;
          this.createdBytxtmodel=null;
          }
        this.ChkAll =false;
        this.lstAccrualsbackup=this.lstAccruals;
        this.config = {
          itemsPerPage:10,
          currentPage: 1,
          totalItems: this.lstAccruals.length
        };
    });
    
     if (this.user.Role==Role.User &&  this.Month != this.getMonths[new Date().getMonth()])
        this.flgSubmit=false;
     else
        this.flgSubmit=true;
  }
  
  openVowdModal(vowdDetails : EnterVoWD | null) {
    const modalRef = this.modalService.open(AddVowdComponent);
    if(vowdDetails ===null)
    {
      modalRef.componentInstance.ModalHeader = "Add VOWD";
      modalRef.componentInstance.Vowd =  vowdDetails; 
      modalRef.componentInstance.BehalfCAI = this.SelectedUser; 
      modalRef.componentInstance.EnterCAI = this.SelectedProvisioningID; 
      modalRef.componentInstance.MonthYear = this.Month +'-'+this.Year;
      modalRef.result.then((result:EnterVoWD) => {
        this.userService.addVOWD(result).subscribe(data=>{
          this.getAllAccrual();
        
        },
        error=>{
         
        }
        );
      }, (reason) => {
       
      });
    }
    else
    {
      modalRef.componentInstance.ModalHeader = "Edit VOWD";
      modalRef.componentInstance.Vowd = vowdDetails; 
      modalRef.componentInstance.BehalfCAI = this.SelectedUser; 
      modalRef.componentInstance.ContractIdentity = vowdDetails.ContractIdentity;
      modalRef.result.then((result:EnterVoWD) => {
        this.userService.UpdateVOWD(result).subscribe(data=>{
          this.getAllAccrual();
       
        },
        error=>{
         
        }
        );
      }, (reason) => {
      });
    }
    
  }

  Applyfilter()
  {
    this.filterVoWD=true;
    this.clearbutton=true;
    this.lstAccrualsbackup2=this.lstAccruals;
   
    this.lstAccruals=this.lstAccruals.filter(
    x => {
    return ((this.SupplierABtxtmodel==null || (x.MstSupplier['SupplierAB']==this.SupplierABtxtmodel))&&
            (this.SupplierNametxtmodel==null || (x.MstSupplier['SupplierName']==this.SupplierNametxtmodel)) &&
            (this.Suppliershnametxtmodel==null || (x.MstSupplier['SupplierShortName']==this.Suppliershnametxtmodel)) &&
            (this.ObjAccounttxtmodel==null || (x.ObjDescr==this.ObjAccounttxtmodel)) &&
            (this.monthyeartxtmodel==null || (x.Period==this.monthyeartxtmodel)) &&
            (this.Cstcentertxtmodel==null || (x.CostCenter==this.Cstcentertxtmodel)) &&
            (this.Divisionfieldtxtmodel==null || (x.DivisionField==this.Divisionfieldtxtmodel)) &&
            (this.VoWDAmounttxtmodel==null || (x.VOWDAmount==this.VoWDAmounttxtmodel)) &&
            (this.Companycodetxtmodel==null || (x.MstCostCenter['CompanyCode']==this.Companycodetxtmodel)) &&
            (this.Areatxtmodel==null || (((x.MstCostCenter['Area_CODE']!=null?x.MstCostCenter['Area_CODE']?.trim():x.MstCostCenter['Area_CODE'])+"-"+(x.MstCostCenter['Area_description']!=null?x.MstCostCenter['Area_description']?.trim():x.MstCostCenter['Area_description']))==this.Areatxtmodel)) &&
            (this.Departmenttxtmodel==null || (x.MstCostCenter['Division']==this.Departmenttxtmodel)) &&
            (this.Workdescriptiontxtmodel==null || (x.DescrOfWork==this.Workdescriptiontxtmodel)) &&
            (this.Submitttedtxtmodel==null || (x.Submitted==this.Submitttedtxtmodel)) &&
            (this.createdBytxtmodel==null || (x.CreatedBy==this.createdBytxtmodel))
          )
  })
  this.openAlertModal("Filter Applied successfully");
  }

  Clearfilter()
  {
    this.filterVoWD=false;
    this.clearbutton=false;
    this.lstAccruals=this.lstAccrualsbackup;
    this.SupplierNametxtmodel=null;
    this.Suppliershnametxtmodel =null;
    this.SupplierABtxtmodel =null;
    this.ObjAccounttxtmodel=null;
    this.monthyeartxtmodel=null;
    this.Cstcentertxtmodel=null;
    this.Divisionfieldtxtmodel=null;
    this.VoWDAmounttxtmodel=null;
    this.Companycodetxtmodel=null;
    this.Areatxtmodel=null;
    this.Departmenttxtmodel=null;
    this.Workdescriptiontxtmodel=null;
    this.Submitttedtxtmodel=null;
    this.createdBytxtmodel=null;
  }
   
  deleteConfirm(deleteVowd : EnterVoWD) {
    this.confirmationDialogService.confirm('Please confirm..', 'Do you really want to Delete. ?')
    .then((confirmed) => {if(confirmed==true){this.deleteVowd(deleteVowd)}})
    .catch(() => {});
  }
  
  deleteAll()
  {
    this.resVowdList=this.lstAccruals.filter(t=>t.selected == true);
    if(this.resVowdList.length ==0){
      this.openAlertModal("Please Select Record To Delete");
      return;
    }
      for(let i=0; i < this.resVowdList.length;i++){
        this.deleteVowd(this.resVowdList[i]);
      }
      this.lstAccrualsbackup=this.lstAccrualsbackup.filter(item=>item!=this.resVowdList);
      this.lstAccrualsbackup2= this.lstAccrualsbackup.filter(item=>item!=this.resVowdList);      
      this.openAlertModal("Records deleted successfully");
  }
  

  deleteVowd(deleteVowd : EnterVoWD)
  {
    deleteVowd.IsActive =false;
    this.userService.UpdateVOWD(deleteVowd).subscribe(data=>{
      this.getAllAccrual()
    },
    error=>{
     
    }
    );
  }

  selectedAll(chk :boolean) {
    for (var i = 0; i < this.lstAccruals.length; i++) {
      this.lstAccruals[i].selected = chk;
    }
  }

  checkIfAllSelected() {
    this.ChkAll = this.lstAccruals.every(function(item:any) {
        return item.selected == true;
      })
  }
   
  submit()
  {
   let flgCurrency =false; 
   let flgobjectAccount=false;
   this.resVowdList=this.lstAccruals.filter(t=>t.selected == true && t.Submitted != "Submitted");
   if(this.resVowdList.length >0){
       for(let i=0; i < this.resVowdList.length;i++){
        if(this.resVowdList[i].CurrencyType?.trim() !="USD"){
          flgCurrency =true;
          break;
        }
        
       }
   }
   else{
    this.openAlertModal("Please Select Record To Submit");
    return;
   }
   if(flgCurrency){
    this.openAlertModal("Please Click Convert in USD button");
    return;
   }
   
   
    let ProvisioningID = this.SelectedUser == "" ? this.SelectedProvisioningID : this.SelectedUser;
    this.userService.getVOWDComment(this.Month +'-'+this.Year,ProvisioningID,ProvisioningID).subscribe(data=>{
      let finalList=[] ;
      if(data!=null && data.length >0){
        this.commentList=data;
        for(let i=0; i < this.resVowdList.length;i++){
          if(finalList.length>0)
          {
           let cnt= finalList.filter(t=>t.supplierab == this.resVowdList[i].SupplierAB && t.objectaccount==this.resVowdList[i].ObjectAccount).length;
           if(cnt>0)
             continue;
          }
          let arrTemp=this.commentList.filter(t=>t.supplierab == this.resVowdList[i].SupplierAB && t.objectaccount==this.resVowdList[i].ObjectAccount);
           if(arrTemp!=null && arrTemp.length >0)
           finalList.push(arrTemp[0]);
          }
      }
      if(finalList!=null && finalList.length >0){
        const modalRef = this.modalService.open(VowdCommentComponent);
        modalRef.componentInstance.vowdCommentList =  finalList; 
        modalRef.result.then((result:AddVOWDComment[]) => {
          this.userService.addVOWDComment(result).subscribe(data=>{
            
                this.resVowdList.forEach(element => {
                  element.IsSubmitted =true;
                });
                this.userService.SubmitVOWD(this.resVowdList).subscribe(data=>{
                  this.getAllAccrual();
                  if(this.clearbutton==true){
                    this.clearbutton=false;
                    this.SupplierNametxtmodel=null;
                    this.Suppliershnametxtmodel =null;
                    this.SupplierABtxtmodel =null;
                    this.ObjAccounttxtmodel=null;
                    this.monthyeartxtmodel=null;
                    this.Cstcentertxtmodel=null;
                    this.Divisionfieldtxtmodel=null;
                    this.VoWDAmounttxtmodel=null;
                    this.Companycodetxtmodel=null;
                    this.Areatxtmodel=null;
                    this.Departmenttxtmodel=null;
                    this.Workdescriptiontxtmodel=null;
                    this.Submitttedtxtmodel=null;
                    this.createdBytxtmodel=null;
                    }
                  this.openAlertModal("Record Submitted Successfully");
                },
                error=>{
                 
                }
                );
            
          },
          error=>{
            
          }
          );
        }, (reason) => {
         
        });
      }
      else{
        
            this.resVowdList.forEach(element => {
              element.IsSubmitted =true;
            });
            this.userService.SubmitVOWD(this.resVowdList).subscribe(data=>{
              this.getAllAccrual()
              this.openAlertModal("Record Submitted Successfully")
            },
            error=>{
              
            }
            );
          
      }
    },
    error=>{
     
    }
    );
  }
  
  openAlertModal(strmsg:any) {
    const modalRef = this.modalService.open(ModalPopupAlertComponent);
    modalRef.componentInstance.strText = strmsg;
    modalRef.result.then((result) => {
    }, (reason) => {
    });   
  }
  
  convertToUSD()
  { 
    if(this.lstCurrency ==null || this.lstCurrency.length <= 0)
    {
      this.userService.getCurrency().subscribe(data=>{
        this.lstCurrency = data;
        for (var i = 0; i < this.lstAccruals.length; i++) {
          if(this.lstAccruals[i].CurrencyType?.trim() !="USD")
          {
            this.lstresCurrency = this.lstCurrency.filter(t=>t.CurrencyCode == this.lstAccruals[i]?.CurrencyType?.trim());
            this.lstAccruals[i].VOWDAmount = (( this.lstAccruals[i]?.VOWDAmount) * +this.lstresCurrency[0]?.DivisionRate).toFixed(2);
            this.lstAccruals[i].CurrencyType ='USD'
          }
          }
       });
    }
    else
      for (var i = 0; i < this.lstAccruals.length; i++) {
        if(this.lstAccruals[i].CurrencyType?.trim() !="USD")
        {
          this.lstresCurrency = this.lstCurrency.filter(t=>t.CurrencyCode == this.lstAccruals[i]?.CurrencyType?.trim());
          this.lstAccruals[i].VOWDAmount = (( this.lstAccruals[i]?.VOWDAmount) * +this.lstresCurrency[0]?.DivisionRate).toFixed(2);
          this.lstAccruals[i].CurrencyType ='USD'
        }
        }
  }
  
  pageChanged(event:any){
    this.config.currentPage = event;
  }
  getAllUsers()
  {
    
    this.userService.viewOnBehalf(this.user.ProvisioningID).subscribe(data=>{
      this.assignUsers = data;
     
    });
  }

  getAllEndUsers()
  {
    this.adminService.viewUsers().subscribe(data=>{
      this.viewUsers = data;    
      this.SelectedProvisioningID = this.user.ProvisioningID;
      this.getAllAccrual();
    });
  }

  Upload(fileData :any){
    this.getAllAccrual();
  }

  filter( column:any,text:any){
    this.lstAccruals = this.lstAccruals.filter(t=>t[column].includes(text));
   }
  
  sortByBusinessUnit()
  {
    this.sortAscBU = !this.sortAscBU;
    if(this.sortAscBU)
        this.lstAccruals = this.lstAccruals.sort((a,b) => a.SupplierAB - b.SupplierAB);
    else
    this.lstAccruals = this.lstAccruals.sort((a,b) => b.SupplierAB - a.SupplierAB);
  }
}
